module.exports = __webpack_public_path__ + "home-partner-mockup.3zw02S8W.png";